"use strict";
/* globals module */
/**
 * @module notificationsSubscriptionsRoute
 * @description Baasic Notifications Subscriptions Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var _1 = require("./");
var NotificationsSubscriptionsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsRoute, _super);
    function NotificationsSubscriptionsRoute(notificationsSubscriptionsAnonymousRoute, notificationsSubscriptionsUsersRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.notificationsSubscriptionsAnonymousRoute = notificationsSubscriptionsAnonymousRoute;
        _this.notificationsSubscriptionsUsersRoute = notificationsSubscriptionsUsersRoute;
        _this.appOptions = appOptions;
        return _this;
    }
    Object.defineProperty(NotificationsSubscriptionsRoute.prototype, "users", {
        get: function () {
            return this.notificationsSubscriptionsUsersRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsRoute.prototype, "anonymous", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c;
    NotificationsSubscriptionsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersRoute)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsAnonymousRoute !== "undefined" && _1.NotificationsSubscriptionsAnonymousRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsUsersRoute !== "undefined" && _1.NotificationsSubscriptionsUsersRoute) === "function" ? _b : Object, typeof (_c = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _c : Object])
    ], NotificationsSubscriptionsRoute);
    return NotificationsSubscriptionsRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsRoute = NotificationsSubscriptionsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
